// extracted by mini-css-extract-plugin
export default {"logoLoader":"LogoLoader_logoLoader__HhEkS"};